import { inventories } from '../model/inventory-type.model'
import { AccountDetails } from '../model/single-transaction/account-details.model'
import { normalExchangeTypes } from '../model/single-transaction/direct-transfer/exchange-type.model'
import {
  DirectTransfer,
  ExchangeMappingModel,
  TransferMappingModel,
  TransferPositionData,
} from './../model/single-transaction/direct-transfer/direct-transfer-transaction.model'

/**
 * Function for Create transfer in/out mapping
 */
export function generateTransferCreateMapping(): TransferMappingModel[] {
  return [
    {
      id: 'entryDate',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Entry Date',
      value: new Date().toISOString().split('T')[0],
      errorMessage: '',
      type: 'date',
    },

    {
      id: 'oldCusip',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Asset ID',
      value: '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'cwanIdentifier',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Asset Identifier',
      value: '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'sourceAccount',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Source Account',
      value: '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'destAccountId',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Dest Account Id',
      value: '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'destinationAccount',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Destination Account',
      value: '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'transferPrice',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Market Price',
      value: '',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'rate',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Rate',
      value: '1',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'units',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Units',
      value: '',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'balanceUnits',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Available Balance units',
      value: '',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'inventoryType',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Inventory Type',
      value: inventories[0].id,
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'exchangeInOutType',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Exchange in/out type',
      value: normalExchangeTypes[0].name,
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'prepaidInterest',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Prepaid Interest',
      value: '',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'interestDue',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Past Interest Due',
      value: '',
      errorMessage: '',
      type: 'number',
    },
  ]
}

/**
 * Function for Edit transfer in/out mapping
 */
export function generateTransferEditMapping(
  transaction: DirectTransfer,
  destinationAccount: AccountDetails | undefined,
): TransferMappingModel[] {
  return [
    {
      id: 'entryDate',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Entry Date',
      value: transaction.entryDate,
      errorMessage: '',
      type: 'date',
    },

    {
      id: 'oldCusip',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Asset ID',
      value: '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'cwanIdentifier',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Asset Identifier',
      value: transaction.cwanIdentifier ?? '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'sourceAccount',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Source Account',
      value: '',
      errorMessage: '',
      type: 'string',
    },

    {
      id: 'destAccountId',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Dest Account Id',
      value: '', //from tranLink
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'destinationAccount',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Destination Account',
      value: destinationAccount
        ? destinationAccount?.accountId + '-' + destinationAccount?.accountName
        : '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'transferPrice',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Market Price',
      value: transaction.transferPrice?.toString() ?? '',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'rate',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Rate',
      value: '1',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'units',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Units',
      value:
        transaction.inventoryType?.toString() == 'ISSUE'
          ? transaction.units.toString()
          : Math.abs(transaction.units).toString(),
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'inventoryType',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Inventory Type',
      value: transaction.inventoryType?.toString() ?? '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'exchangeInOutType',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Exchange in/out type',
      value: normalExchangeTypes[0].name,
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'prepaidInterest',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Prepaid Interest',
      value: transaction.dataMap?.prepaidInterest?.toString() ?? '',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'interestDue',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Past Interest Due',
      value: transaction.dataMap?.interestDue?.toString() ?? '',
      errorMessage: '',
      type: 'number',
    },
  ]
}

/**
 * Function for Create exchange in/out mapping
 */
export function generateExchangeCreateMapping(): ExchangeMappingModel[] {
  return [
    {
      id: 'entryDate',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Entry Date',
      value: new Date().toISOString().split('T')[0],
      errorMessage: '',
      type: 'date',
    },

    {
      id: 'oldCusip',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Old Asset ID',
      value: '',
      errorMessage: 'Old Cusip is required',
      type: 'string',
    },
    {
      id: 'oldCwanIdentifier',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Old Asset Identifier',
      value: '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'newCusip',
      validityStatus: 'valid',
      isEditable: true,
      field: 'New Asset ID',
      value: '',
      errorMessage: 'New Cusip is required',
      type: 'string',
    },
    {
      id: 'newCwanIdentifier',
      validityStatus: 'valid',
      isEditable: false,
      field: 'New Asset Identifier',
      value: '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'sourceAccount',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Source Account',
      value: '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'transferPrice',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Market Price',
      value: '',
      errorMessage: 'Market Price is required',
      type: 'number',
    },
    {
      id: 'rate',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Rate',
      value: '1',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'units',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Units',
      value: '',
      errorMessage: 'Units is required',
      type: 'number',
    },
    {
      id: 'balanceUnits',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Available Balance units',
      value: '',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'inventoryType',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Inventory Type',
      value: inventories[0].id,
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'exchangeInOutType',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Exchange in/out type',
      value: normalExchangeTypes[0].name,
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'isConversion',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Is Conversion',
      value: false,
      errorMessage: '',
      type: 'string',
    },
  ]
}

/**
 * Function for Create direct transfer in/out from Positions
 */
export function generateTransferFromPosition(
  transInput: TransferPositionData,
): TransferMappingModel[] {
  return [
    {
      id: 'entryDate',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Entry Date',
      value: transInput.sessionReconDate,
      errorMessage: '',
      type: 'date',
    },
    {
      id: 'oldCusip',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Asset ID',
      value: transInput.assetId,
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'cwanIdentifier',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Asset Identifier',
      value: transInput.cwanIdentifier ?? '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'sourceAccount',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Source Account',
      value: transInput.accountId.toString(),
      errorMessage: '',
      type: 'string',
    },

    {
      id: 'destAccountId',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Dest Account Id',
      value: '', //from tranLink
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'destinationAccount',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Destination Account',
      value: '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'transferPrice',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Market Price',
      value: '',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'rate',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Rate',
      value: '1',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'units',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Units',
      value: transInput.units.toString(),
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'balanceUnits',
      validityStatus: 'valid',
      isEditable: false,
      field: 'Available Balance units',
      value: '',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'inventoryType',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Inventory Type',
      value: transInput.inventoryType ?? '',
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'exchangeInOutType',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Exchange in/out type',
      value: normalExchangeTypes[0].name,
      errorMessage: '',
      type: 'string',
    },
    {
      id: 'prepaidInterest',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Prepaid Interest',
      value: '',
      errorMessage: '',
      type: 'number',
    },
    {
      id: 'interestDue',
      validityStatus: 'valid',
      isEditable: true,
      field: 'Past Interest Due',
      value: '',
      errorMessage: '',
      type: 'number',
    },
  ]
}

/**
 * Bank-loan / mortgage-only Exit Fee Receivable row.
 * Only added to the grid when the security is a bank loan or mortgage.
 */
export function getExitFeeReceivableRow(
  value?: string | number,
): TransferMappingModel {
  return {
    id: 'exitFeeReceivable',
    validityStatus: 'valid',
    isEditable: true,
    field: 'Exit Fee Receivable',
    value: value != null ? value.toString() : '',
    errorMessage: '',
    type: 'number',
  }
}

/**
 * extra Collateral fields
 */
export function getCollateralBroker(
  collateralBrokerLabel: string,
  collateralValue?: string,
): TransferMappingModel | ExchangeMappingModel {
  return {
    id: 'collateralBroker',
    validityStatus: collateralValue ? 'valid' : 'invalid',
    isEditable: true,
    field: collateralBrokerLabel,
    value: collateralValue ?? '',
    errorMessage: collateralValue ? '' : 'Collateral Broker must be specified',
    type: 'string',
  }
}
